<template>
    <div class="ader-result">
        <p class="result-icon"><img :src="iconSucc" /></p>
        <h3 class="result-title">修改成功</h3>
        <p class="result-desc">恭喜您，信息更新成功</p>
        <p class="result-btn">
            <el-button type="primary" plain @click="toList">返回列表</el-button> &nbsp;
            <el-button plain @click="back">查看详情</el-button>
        </p>
    </div>
</template>

<script>
import IconSucc from '@/assets/image/icon/success-icon_140_140.png';

export default {
    name: 'AdvertiserManagePrivateEditAderResult',
    data: () => ({
        iconSucc: IconSucc
    }),
    methods: {
        back () {
            this.$router.go(-1);
        },
        toList () {
            this.$router.replace({ name: 'AdvertiserManagePrivateList' });
        }
    }
};
</script>

<style lang="less" scoped>
.ader-result {
    text-align: center;

    .result-icon {
        img {
            width: 70px;
        }
    }
    .result-title {
        font-size: 22px;
        padding: 16px 0 0 0;
    }
    .result-desc {
        font-size: 14px;
        color: #666;
        margin-bottom: 50px;
    }
}
</style>
